import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { IonicModule } from '@ionic/angular';

let UiCWarningComponent = class UiCWarningComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], UiCWarningComponent.prototype, "image", void 0);
UiCWarningComponent = __decorate([
    Component({
        selector: 'ui-c-warning',
        template: "<div class=\"warning border ion-padding\">\n  <ion-row class=\"ion-justify-content-center\">\n    <ion-col size=\"6\" class=\"ion-text-center\">\n      <svg-icon [stretch]=\"false\" [src]=\"image\"></svg-icon>\n    </ion-col>\n  </ion-row>\n  <ion-row class=\"ion-padding-horizontal\">\n    <ion-text class=\"ion-text-left ion-padding\">\n      <ng-content></ng-content>\n    </ion-text>\n  </ion-row>\n</div>\n",
        styles: [""]
    })
], UiCWarningComponent);

let UiCWarningModule = class UiCWarningModule {
};
UiCWarningModule = __decorate([
    NgModule({
        declarations: [UiCWarningComponent],
        imports: [IonicModule, AngularSvgIconModule.forRoot()],
        exports: [UiCWarningComponent],
    })
], UiCWarningModule);

/*
 * Public API Surface of ui-c-warning
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCWarningComponent, UiCWarningModule };
//# sourceMappingURL=wlp-ui-c-warning.js.map
